import React, {useState} from 'react'
import FontAwesome from 'react-fontawesome';
import TreeMenu, { defaultChildren, ItemComponent } from 'react-simple-tree-menu';
import NPSpinnerModal from '../NPSpinnerModal'
//import 'react-simple-tree-menu/dist/main.css';
import './style.scss'
import axios from 'axios';

function NPTreeMenu(props) {
    const { data, className, dataCallback, level0DefaultOpen, header, toggleContentLoading } = props
    let defaultOpenNodes = []

    // set label as key to allow defaultOpen - does not seem to work with ints.
    

    if (level0DefaultOpen) {
        data.forEach(item => item.key = item.label)
        defaultOpenNodes = data.map(o => o.label)
    }

    async function fetchDataFromItemUrl(url) {
        if (url == undefined) return false;
        toggleContentLoading && toggleContentLoading(true);

        await axios.get(url, {headers: header})
            .then(result => {
                dataCallback(result)
                toggleContentLoading && toggleContentLoading(false);
            })
            .catch(err => {
                console.log(err)
                toggleContentLoading && toggleContentLoading(false);
            })
    }

    const ClosedIcon = () => {
        return <FontAwesome name="caret-right" className="bigger" />
    }

    const OpenedIcon = () => {
        return <FontAwesome name="caret-down" className="bigger" />
    }



    return (
        <section className={`${className} np-treeMenu`}>
            <TreeMenu
                data={data}
                disableKeyboard={false}
                hasSearch={false}
                initialOpenNodes={defaultOpenNodes}
                resetOpenNodesOnDataUpdate={false}
            >
                {({ items }) => (
                    <ul>
                        {items.map(({ onClick, toggleNode, key, ...props }) => (
                            <ItemComponent
                                {...props}
                                closedIcon={ClosedIcon()}
                                openedIcon={OpenedIcon()}
                                key={key}
                                toggleNode={toggleNode}
                                onClick={(e) => {
                                    // HIJACK ONCLICK HANDLER TO ENABLE toggleNode ON REGULAR CLICK (CATEGORIES)
                                    const { url } = props

                                    // Call default onClick behaviour
                                    onClick()

                                    // ToggleNode open on click if it has children
                                    toggleNode && toggleNode()

                                    // Call parent function with url to populate screen
                                    fetchDataFromItemUrl(url)
                                }} />
                        ))}
                    </ul>
                )}
            </TreeMenu>
            

        </section>

    );
}

export default NPTreeMenu;